import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getBIT } from 'services/glass-management/glassManagement';

export const fetchBit = createAsyncThunk('glass/bit/fetch', async (filters, { signal }) => {
    const res = await getBIT(filters, signal);
    return { data: res };
});

export const bitSlice = createSlice({
    name: 'glassBit',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchBit.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBit.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action?.payload?.data;
            })
            .addCase(fetchBit.rejected, (state, action) => {
                // Do nothing if aborted to continue loading
                if (action.meta.aborted)
                    return;

                state.loading = false;
                state.error = action?.error?.message ?? 'Failed to load BIT';
                state.data = null;
            });
    }
});

export default bitSlice.reducer;
